import { NgModule } from '@angular/core';
import { DateAgoPipe } from './date-ago.pipe';
import { DynamicFormTranslatePipe } from './dynamic-form-translate.pipe';
import { VtFilterPermissionsPipe } from './data-filter-permissions.pipe';

@NgModule({
  declarations: [
    DateAgoPipe,
    DynamicFormTranslatePipe,
    VtFilterPermissionsPipe,
  ],
  exports: [DateAgoPipe, DynamicFormTranslatePipe, VtFilterPermissionsPipe],
})
export class PipesModule {}
